import React from "react";
import ErrorPage from "@swiggy-private/gamification-frontend-ui/dist/ErrorPage";
import HeadComponent from "../Head";

interface ErrorWrapperProps {
    ctaHandler: VoidFunction;
    ctaText: string;
    heading?: string;
    subHeading?: string;
    showCloseIcon?: boolean;
    closeIconClick?: VoidFunction;
}

const ErrorWrapper = ({
    ctaHandler,
    ctaText,
    heading,
    subHeading,
    showCloseIcon = false,
    closeIconClick,
}: ErrorWrapperProps) => {
    return (
        <>
            <HeadComponent />
            <ErrorPage
                ctaHandler={ctaHandler}
                ctaText={ctaText}
                heading={heading}
                subHeading={subHeading}
                showCloseIcon={showCloseIcon}
                closeIconClick={closeIconClick}
            />
        </>
    );
};

export default ErrorWrapper;
